import axios from "axios";

const setupAxiosInterceptors = (history) => {
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("authToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        localStorage.removeItem("authToken");
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
